(function() {
    'use strict';

    /** @see The <a href="http://jira.odigeo.com/wiki/display/MOBILEWEB/Advertisement">Confluence page</a> */
    /**
     * Enhances an element or a list of elements to show GPT ads on them.
     * @param {List} advList List of elements to be enhanced
     * @param {Boolean} addSearchTargetings Boolean to indicate if search params targetings should be added or not
     * @param {Boolean} usePageUrlParam Boolean
     * @param {Boolean} enableSingleRequest Boolean
     */
    Odigeo.UIElements.enhanceAdvertisementGpt = function(advList, addSearchTargetings, usePageUrlParam, enableSingleRequest) {
        var randomAdGroup = function() {
            var rand = Math.random();
            var result = '';
            switch (true) {
                case (rand < 0.09):
                    result = 'ad_ex' + (Math.floor(100 * rand));
                    break;
                case (rand < 0.19):
                    result = 'ad_bc';
                    break;
                default:
                    result = 'ad_opt';
                    break;
            }
            return result;
        };
        var googleGptUrl = '//securepubads.g.doubleclick.net/tag/js/gpt.js';
        var addTarget = function(key, value, lowercase) {
            var valString = String(value);
            // If value is empty or undefined cause it's not possible to retrive it, then send a 0
            if (!_.isUndefined(value) && !_.isEmpty(valString)) {
                googletag.pubads().setTargeting(key, lowercase ? valString.toLowerCase() : valString);
            } else {
                googletag.pubads().setTargeting(key, '0');
            }
        };

        var applySearchTargetings = function() {
            var searchData = JSON.parse(Odigeo.Session.get('searchParameters'));
            var firstSegment;
            var lastSegment;
            var depDate;
            var destDate;
            var weekday;
            var currentResultPage = Odigeo.SessionScope.gpt.page > 1 ? 'p' + Odigeo.SessionScope.gpt.page : ' ';
            var arrivalCity;
            var departureCity;
            var iataDepartureAirport;
            var iataArrivalAirport;
            var intentMedia = Odigeo.SessionScope.tmSettings.intentMedia;
            var intentMediaScore = _.isObject(intentMedia) && _.isObject(intentMedia.score) && intentMedia.score.group;

            if (!_.isEmpty(searchData) && !!searchData.searchSegments.length) {
                weekday = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
                firstSegment = searchData.searchSegments[0];
                // In case of MD trip, arrival data is picked from 2nd segment instead of the last segment
                lastSegment = searchData.type === 'multipleTrip' ? searchData.searchSegments[1] :
                    searchData.searchSegments[searchData.searchSegments.length - 1];
                depDate = new Date(firstSegment.dateStr);
                destDate = new Date(lastSegment.dateStr);
                iataDepartureAirport = !_.isUndefined(firstSegment.departure.iata) ?
                    firstSegment.departure.iata.toLowerCase() : 0;
                iataArrivalAirport = !_.isUndefined(firstSegment.destination.iata) ?
                    firstSegment.destination.iata.toLowerCase() : 0;
                departureCity = !_.isUndefined(firstSegment.departure.cityCode) ?
                    firstSegment.departure.cityCode.toLowerCase() : iataDepartureAirport;
                arrivalCity = !_.isUndefined(firstSegment.destination.cityCode) ?
                    firstSegment.destination.cityCode.toLowerCase() : iataArrivalAirport;

                addTarget('pos', 'wait', true);
                addTarget('dep', !_.isUndefined(firstSegment.departure.iata) ?
                    firstSegment.departure.iata.toLowerCase() : departureCity, true);
                addTarget('depcity', departureCity, true);
                addTarget('depcountry', firstSegment.departure.countryCode, true);
                addTarget('arr', !_.isUndefined(firstSegment.destination.iata) ?
                    firstSegment.destination.iata.toLowerCase() : arrivalCity, true);
                addTarget('arrcity', arrivalCity, true);
                addTarget('arrcountry', firstSegment.destination.countryCode, true);
                addTarget('depweek', weekday[depDate.getDay()]);
                addTarget('depday', depDate.getDate());
                addTarget('depmonth', depDate.getMonth() + 1);
                addTarget('depyear', depDate.getYear() + 1900);
                addTarget('arrweek', weekday[destDate.getDay()], true);
                addTarget('arrday', destDate.getDate());
                addTarget('arrmonth', destDate.getMonth() + 1);
                addTarget('arryear', destDate.getYear() + 1900);
                addTarget('nadults', searchData.numAdults);
                addTarget('nchildren', searchData.numChildren);
                addTarget('ninfants', searchData.numInfants);
                addTarget('page', currentResultPage);
                addTarget('cabclass', searchData.cabinClass);

                if (intentMediaScore) {
                    addTarget('intent', intentMediaScore, true);
                }
            }
        };

        $.getScript(googleGptUrl, function() {
            if(_.has(window, 'tC.event.amazon_trigger')){
                window.tC.event.amazon_trigger();
            }
            var googletag = window.googletag;
            // Error prevention in case the user have some kind of ad block extension interfering
            if ((window.googletag || googletag) && Odigeo.SessionScope.gpt) {
                googletag.cmd.push(function() {
                    var defaultTargetings = Odigeo.SessionScope.gpt.targetings;
                    var target;
                    var isUserLoggedIn = window.tc_vars?.user_prime_subscription === 'subscriber';

                    // Set targetings
                    for (target in defaultTargetings) {
                        if (defaultTargetings.hasOwnProperty(target)) {
                            addTarget(target, defaultTargetings[target]);
                        }
                    }

                    // privatesales depends only on login status — always send regardless of search data
                    addTarget('privatesales', isUserLoggedIn);

                    if (addSearchTargetings) {
                        applySearchTargetings();
                    }

                    // This only apply to desktop sites
                    if (usePageUrlParam) {
                        googletag.pubads().set('page_url', String(Odigeo.SessionScope.gpt.pageUrl));
                    }

                    // Enable single request allows to download all ads requested at the same time
                    if (enableSingleRequest) {
                        googletag.pubads().enableSingleRequest();
                    }
                    googletag.pubads().collapseEmptyDivs();
                    googletag.pubads().enableAsyncRendering();
                    googletag.pubads().addEventListener('slotRenderEnded', function(event) {
                        if (event.slot.getSlotElementId() === 'adLeaderBoard') {
                            $('#adLeaderBoard').removeClass('odf-hidden');
                        }
                    });
                    googletag.enableServices();

                    advList.each(function() {
                        var adv = $(this);
                        var dataset = adv.data();
                        var product = dataset.advProduct;
                        var zone = dataset.advZone;
                        var containerPos = dataset.advContPos;
                        var divId = adv.prop('id');
                        var size;
                        if (!_.isUndefined(Odigeo.SessionScope.gpt.slots[divId])) {
                            googletag.pubads().refresh([Odigeo.SessionScope.gpt.slots[divId]]);
                        } else {
                            if (_.has(dataset, 'advSize')) {
                                size = dataset.advSize;
                            } else {
                                size = [
                                    [dataset.advWidth, dataset.advHeight],
                                ];
                            }
                            Odigeo.SessionScope.gpt.slots[divId] = googletag.defineSlot('/4121/' +
                                Odigeo.SessionScope.gpt.domainConfig.siteId +
                                '_sites/' + Odigeo.SessionScope.gpt.domainConfig.domain + '/' + product + '/' + zone, size, divId)
                                .setTargeting('ad_group', randomAdGroup())
                                .addService(googletag.pubads())
                                .setTargeting('pos', containerPos);
                            googletag.display(divId);
                        }
                    });
                });
            }
        });
    };

    /**
     * Enhances an element or a list of elements to show GPT ads on them WITHOUT using calls to google tag js library.
     * In this case, an Image + Link are constructed to show advertisements so, when user clicks on an ad, a new tab is opened
     * in background so user doesnt loose focus and keep seeing OneFront website.
     * @param {Element} el Element to be enhanced
     */
    Odigeo.UIElements.enhanceAdvertisementGptNonJS = function(el) {
        var $el = (el instanceof $) ? el : $(el);
        var dataset;
        var targetings = {};
        var hrefUrl = location.protocol + '//pubads.g.doubleclick.net/gampad/jump?';
        var slotUrl;
        var srcUrl = location.protocol + '//pubads.g.doubleclick.net/gampad/ad?';
        var searchData = JSON.parse(Odigeo.Session.get('searchParameters'));
        var isUserLoggedIn = window.tc_vars?.user_prime_subscription === 'subscriber';
        var isUndefinedOrNull = function(val) {
            return _.isUndefined(val) || _.isNull(val);
        };
        var setTargetings = function(searchData) {
            var firstSegment;
            var lastSegment;
            var depDate;
            var destDate;
            var weekday = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
            var arrivalName;
            var departureName;
            var departureCityCode;
            var arrivalCityCode;
            firstSegment = searchData.searchSegments[0];
            // In case of MD trip, arrival data is picked from 2nd segment instead of the last segment
            lastSegment = searchData.type === 'multipleTrip' ? searchData.searchSegments[1] :
                searchData.searchSegments[searchData.searchSegments.length - 1];
            depDate = new Date(firstSegment.dateStr);
            destDate = new Date(lastSegment.dateStr);

            departureName = !isUndefinedOrNull(firstSegment.departure.iata) ? firstSegment.departure.iata :
                firstSegment.departure.city;
            arrivalName = !isUndefinedOrNull(firstSegment.destination.iata) ? firstSegment.destination.iata :
                firstSegment.destination.city;
            departureCityCode = !isUndefinedOrNull(firstSegment.departure.cityCode) ?
                firstSegment.departure.cityCode : departureName;
            arrivalCityCode = !isUndefinedOrNull(firstSegment.destination.cityCode) ?
                firstSegment.destination.cityCode : arrivalName;

            return {
                pos: dataset.advContPos,
                dep: !isUndefinedOrNull(departureName) ? departureName.toLowerCase() : 0,
                depcity: !isUndefinedOrNull(departureCityCode) ? departureCityCode.toLowerCase() : 0,
                depcountry: !isUndefinedOrNull(firstSegment.departure.countryCode) ? firstSegment.departure.countryCode : 0,
                arr: !isUndefinedOrNull(arrivalName) ? arrivalName.toLowerCase() : 0,
                arrcity: !isUndefinedOrNull(arrivalCityCode) ? arrivalCityCode.toLowerCase() : 0,
                arrcountry: !isUndefinedOrNull(firstSegment.destination.countryCode) ? firstSegment.destination.countryCode : 0,
                depweek: !isUndefinedOrNull(weekday[depDate.getDay()]) ? weekday[depDate.getDay()] : 0,
                depday: !isUndefinedOrNull(depDate.getDate()) ? depDate.getDate() : 0,
                depmonth: !isUndefinedOrNull(depDate.getMonth()) ? depDate.getMonth() + 1 : 0,
                depyear: !isUndefinedOrNull(depDate.getYear()) ? depDate.getYear() + 1900 : 0,
                arrweek: !isUndefinedOrNull(weekday[destDate.getDay()]) ? weekday[destDate.getDay()] : 0,
                arrday: !isUndefinedOrNull(destDate.getDate()) ? destDate.getDate() : 0,
                arrmonth: !isUndefinedOrNull(destDate.getMonth()) ? destDate.getMonth() + 1 : 0,
                arryear: !isUndefinedOrNull(destDate.getYear()) ? destDate.getYear() + 1900 : 0,
                nadults: !isUndefinedOrNull(searchData.numAdults) ? searchData.numAdults : 0,
                nchildren: !isUndefinedOrNull(searchData.numChildren) ? searchData.numChildren : 0,
                ninfants: !isUndefinedOrNull(searchData.numInfants) ? searchData.numInfants : 0,
                pa: 0,
                palist: 0,
                triptype: 0,
                privatesales: isUserLoggedIn,
            };
        };
        var setImage = function($el, dataset, targetings, srcUrl, slotUrl, hrefUrl) {
            var $link;
            var urlParams = {
                sz: dataset.advSize,
                c: new Date().getTime(),
                tile: 1,
                t: targetings,
                pos: dataset.advContPos,
            };
            var $image = $('<img>', {
                src: srcUrl + slotUrl + $.param(urlParams),
                border: 0,
                alt: '',
                width: dataset.advWidth,
                height: dataset.advHeight,
            });
            if (dataset.clickable === false) {
                $el.empty().append($image);
            } else {
                $link = $('<div>', {'data-url': hrefUrl + slotUrl + $.param(urlParams)});
                $link.append($image);
                $el.empty().append(Odigeo.UIElements.enhanceLinkOpenNewTabBackground($link));
            }
        };
        var getSlotUrl = function(dataset) {
            var config = Odigeo.SessionScope.gpt.domainConfig;
            var advProduct = _.isUndefined(dataset.advProduct) ? '' : ('/' + dataset.advProduct);
            return 'iu=/4121/' + config.siteId + '_sites/' + config.domain + advProduct + '/' + dataset.advZone + '&';
        };
        if (!_.isUndefined(Odigeo.SessionScope.gpt)) {
            dataset = $el.data();
            slotUrl = getSlotUrl(dataset);
            // Construct targetings
            if (!_.isEmpty(searchData) && !!searchData.searchSegments.length) {
                targetings = setTargetings(searchData);
                setImage($el, dataset, targetings, srcUrl, slotUrl, hrefUrl);
            } else {
                targetings = { privatesales: isUserLoggedIn };
                setImage($el, dataset, targetings, srcUrl, slotUrl, hrefUrl);
            }
        }
    };

    /** @see The <a href="http://jira.odigeo.com/wiki/display/MOBILEWEB/Advertisement">Confluence page</a> */
    /**
     * Enhances an element or a list of elements to show AdSense ads on them.
     * @param {List} advList List of elements to be enhanced
     * @param {Object} product
     * @return {*}
     */
    Odigeo.UIElements.enhanceAdvertisementAdSense = function(advList, product) {
        var searchData;
        var departureInfo;
        var queryKeyWord;
        var channel;
        var query;
        var queryContext;
        var pageOptions;
        var adSenseCallArgs = [];
        var $advList = (advList instanceof $) ? advList : $(advList);
        var skipEnhance = _.reduce($advList, (memo, el) => {
            var enhanced = $(el).attr('data-skip-enhance') === 'true';
            if (enhanced) {
                // Remove previously enhanced elements from the list of elements to be enhanced
                $advList.splice(_.indexOf($advList, el), 1);
            }
            return memo && enhanced;
        }, true);

        if (skipEnhance) {
            return $advList;
        }

        $advList.attr({'data-skip-enhance': true});

        (function(G, o, O, g, L, e) {
            G[g] = G[g] || function() {
                (G[g]['q'] = G[g]['q'] || []).push(
                    arguments);
            };
            G[g]['t'] = new Date().getTime();
            L = o.createElement(O);
            e = o.getElementsByTagName(O)[0];
            L.async = 1;
            L.src = '//www.google.com/adsense/search/async-ads.js';
            e.parentNode.insertBefore(L, e);
        })(window, document, 'script', '_googCsa');

        if ((window._googCsa || _googCsa) && Odigeo.SessionScope.ads) {
            Odigeo.trigger('adsense:available');

            searchData = JSON.parse(Odigeo.Session.get('searchParameters'));

            // If product is null, we are not in Dynpack Flow.
            if (!_.isEmpty(product)) {
                queryKeyWord = Odigeo.SessionScope.ads.types['dp-' + product].query;
                channel = String(Odigeo.SessionScope.ads.types['dp-' + product].channel);
                queryContext = String(Odigeo.SessionScope.ads.types['dp-' + product].query);
            } else {
                queryKeyWord = Odigeo.SessionScope.ads.pageOptions.query;
                channel = String(Odigeo.SessionScope.ads.pageOptions.channel);
                queryContext = String(Odigeo.SessionScope.ads.pageOptions.query);
            }
            if (!_.isEmpty(searchData) && !!searchData.searchSegments.length) {
                departureInfo = product === 'hotels' ? '' : ' ' + searchData.searchSegments[0].departure.city;
                query = queryKeyWord + departureInfo + ' ' + searchData.searchSegments[0].destination.city;
            } else {
                query = queryKeyWord;
            }

            pageOptions = {
                'pubId': String(Odigeo.SessionScope.ads.pageOptions.pubId),
                'query': String(query),
                'queryContext': String(queryContext),
                'linkTarget': '_blank',
                'titleBold': Odigeo.SessionScope.ads.pageOptions.titleBold,
                'rolloverLinkUnderline': Odigeo.SessionScope.ads.pageOptions.rolloverLinkUnderline,
                'rolloverLinkColor': String(Odigeo.SessionScope.ads.pageOptions.rolloverLinkColor),
                'hl': String(Odigeo.SessionScope.ads.pageOptions.hl),
                'adLayout': 'sellerFirst',
                'channel': String(channel),
            };

            adSenseCallArgs.push('ads');
            adSenseCallArgs.push(pageOptions);

            $advList.each(function() {
                var $adv = $(this);
                if ($adv.length !== 0) {
                    var number = $adv.data('advNumber');
                    var width = $adv.data('advWidth') + 'px';
                    var lines = $adv.data('advLines');
                    var adblock = {
                        'container': $adv.prop('id'),
                        'number': number,
                        'width': width,
                        'lines': lines,
                        'colorTitleLink': String(Odigeo.SessionScope.ads.style.colorTitleLink),
                        'colorDomainLink': String(Odigeo.SessionScope.ads.style.colorDomainLink),
                        'colorBorder': String(Odigeo.SessionScope.ads.style.colorBorder),
                    };
                    adSenseCallArgs.push(adblock);
                }
            });
            _googCsa.apply(this, adSenseCallArgs); // eslint-disable-line no-undef
        }
    };

    /**
     * This function downloads an img from Google GPT server by using an ID comming from CMS.
     * In this way, we can track how many times carousel's images are shown to users (one per image downloaded).
     * @param {Element} $el element where image will be injected
     */
    Odigeo.UIElements.cmsTrackAdvertisement = function($el) {
        var srcUrl;
        var slot;
        var urlParams;
        var id = $el.data('cmsTrack');
        var $imgContainer = $el.find('.cms_tracking_img_container');
        var page = ('dp flights hotels of2Iframe deals trains').match($('body').attr('data-app'))?.[0] || 'home';

        if (!_.isEmpty(id) && !_.isUndefined(Odigeo.SessionScope.gpt)) {
            slot = '/4121/' + Odigeo.SessionScope.gpt.domainConfig.siteId + '_sites/' +
                Odigeo.SessionScope.gpt.domainConfig.domain + '/Pixel/' + page;
            srcUrl = location.protocol + '//pubads.g.doubleclick.net/gampad/ad?';
            urlParams = {
                iu: slot,
                sz: '1x1',
                t: $.param({'pixel': id}),
                c: new Date().getTime(),
            };

            $imgContainer.html($('<img>', {src: srcUrl + $.param(urlParams)}));
        }
    };
}());
